export default __webpack_public_path__ + "static/media/logosine.e14c156f.png";